<div *ngIf="visible" class="message bot typing-message">
  <div class="typing-indicator">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
  <span class="typing-indicator-message">{{ message }}</span>
</div>